import { h } from 'preact';
import App from './app'
const Container = () => {
    return (
        <div id="app">
            <div className="container align-items-center justify-content-center d-flex">
                <div className="card center mt-10" style="max-width: 750px">
                    <div className="card-body">
                        {/* Preact component starts here */}
                        <App />
                        {/* Preact component ends */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Container;
